export default __webpack_public_path__ + "static/media/red-3.963f060e.png";